module.exports = __webpack_public_path__ + "fa735e43100e6ba7d02afc2d27ff088c.svg";